(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["af-style-with"] && !Shopify.designMode) return;
  try {
    /* AF Style it with — mobile carousel chevrons. Pure scroll-snap
     underneath (swipe always works); the pair scrolls one card and greys
     out at the ends. Re-binds on shopify:section:load for the editor. */
  (() => {
    const bindAll = () => {
      document.querySelectorAll('.af-sw').forEach((root) => {
        if (root.dataset.afSwBound) return;
        const track = root.querySelector('[data-af-sw-track].af-sw__grid--m-carousel');
        const prev = root.querySelector('[data-af-sw-prev]');
        const next = root.querySelector('[data-af-sw-next]');
        if (!track || (!prev && !next)) return;
        root.dataset.afSwBound = '1';

        const step = () => {
          const cards = track.querySelectorAll('.af-sw__card');
          if (cards.length < 2) return track.clientWidth;
          return cards[1].offsetLeft - cards[0].offsetLeft;
        };
        const maxScroll = () => track.scrollWidth - track.clientWidth;

        const mark = (btn, end) => {
          if (!btn) return;
          btn.classList.toggle('is-end', end);
          btn.toggleAttribute('disabled', end);
        };

        const sync = () => {
          mark(prev, track.scrollLeft <= 2);
          mark(next, track.scrollLeft >= maxScroll() - 2);
        };

        prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

        let raf = null;
        track.addEventListener(
          'scroll',
          () => {
            if (raf) return;
            raf = requestAnimationFrame(() => {
              raf = null;
              sync();
            });
          },
          { passive: true }
        );
        window.addEventListener('resize', sync);
        sync();
      });
    };

    bindAll();
    document.addEventListener('shopify:section:load', () => bindAll());
  })();
  } catch(e) { console.error(e); }
})();

})();
